import {Rate} from "crqlar-react-common/dist/models/rate/rate.model";
import {Service} from "crqlar-react-common/dist/models/service/service.model";
import {ServiceCategory} from "crqlar-react-common/dist/models/serviceCategory/serviceCategory.model";
import {findRateByDate} from "crqlar-react-common/dist/utils/rate.util";
import {amountCentsOf} from "./serviceAutofill";

/** Every rate id of [services], once and sorted: one rate calculation prices the whole picker. */
export const serviceRateIds = (services: Service[]): string[] => (
    Array.from(new Set(services.flatMap(service => service.rateIds ?? []))).sort()
);

/**
 * The service's price on [date], picked from a calculation over many services' rates the way the
 * charge flow picks it; undefined when the service has no rate that day.
 */
export const serviceOptionPriceCents = (service: Service, calculated: Rate[] | null | undefined, date: Date): number | undefined => {
    const ownIds = service.rateIds ?? [];
    const own = (calculated ?? []).filter(rate => !!rate.id && ownIds.includes(rate.id));
    return own.length ? amountCentsOf(findRateByDate(own, date)?.price) : undefined;
};

/** The option's second line, "60 min · Massages": the duration and the categories there are. */
export const serviceOptionDetail = (
    service: Service,
    categories: ServiceCategory[],
    minutesText: (minutes: number) => string
): string => {
    const categoryNames = (service.categoryIds ?? [])
        .map(id => categories.find(category => category.id === id)?.name)
        .filter(Boolean)
        .join(', ');

    return [
        service.durationMinutes != null ? minutesText(service.durationMinutes) : undefined,
        categoryNames || undefined,
    ].filter(Boolean).join(' · ');
};
